import React from 'react';
import { Box, Container, CssBaseline } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';

interface LayoutProps {
  children?: React.ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  disableGutters?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ 
  children, 
  maxWidth = false, // Use full width by default for modern full-screen apps
  disableGutters = false // Enable gutters for proper spacing
}) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh',
      width: '100%',
      background: 'linear-gradient(135deg, #fafafa 0%, #f8fafc 50%, #ffffff 100%)',
    }}>
      <CssBaseline />
      <Navbar />
      
      {/* Main content area with modern professional design */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          mt: 1, // Minimal margin for AppBar
          minHeight: 'calc(100vh - 64px)',
          position: 'relative',
          width: '100%',
          overflow: 'auto', // Allow scrolling for content
          overflowX: 'hidden' // Prevent horizontal scroll issues
        }}
      >
        {maxWidth === false ? (
          <Box sx={{ 
            height: '100%', 
            pt: disableGutters ? 0 : 2, // Consistent top padding
            px: disableGutters ? 0 : 3, // Side padding
            pb: disableGutters ? 0 : 3, // Bottom padding
            position: 'relative',
            width: '100%',
            maxWidth: '100%',
            overflow: 'visible'
          }}>
            {children || <Outlet />}
          </Box>
        ) : (
          <Container 
            maxWidth={maxWidth} 
            sx={{ 
              pt: disableGutters ? 0 : 2, // Consistent top padding
              px: disableGutters ? 0 : 3, // Side padding
              pb: disableGutters ? 0 : 3, // Bottom padding
              height: '100%',
              position: 'relative',
              overflow: 'visible',
              width: '100%'
            }}
          >
            {children || <Outlet />}
          </Container>
        )}
      </Box>
    </Box>
  );
};

export default Layout;